import useSWR from 'swr'

export default function useGoogleLocation(searchTerm, swrConfig = {}) {
  const fetcher = (...args) => fetch(...args)
    .then(res => res.json())

  return useSWR(searchTerm ? `/api/v1/coordinates/?q=${searchTerm}` : '', fetcher, {
    revalidateOnMount: true,
    ...swrConfig,
  })
}